{
    "(save {highestYearlyDiscount}%)": "{highestYearlyDiscount}% besparing",
    "{amount} days free": "{amount} dagen gratis",
    "{amount} off": "{amount} korting",
    "{amount} off for first {number} months.": "{amount} korting voor de eerste {number} maanden.",
    "{amount} off for first {period}.": "{amount} korting voor de eerste {period}.",
    "{amount} off forever.": "{amount} korting voor altijd.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% korting",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} ontvangt de nieuwsbrief {newsletterName} niet meer.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} ontvangt geen e-mails meer als iemand op je reacties reageert.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} ontvangt deze nieuwsbrief niet meer.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dagen gratis",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Account",
    "Account details updated successfully": "Accountgegevens succesvol bijgewerkt",
    "Account settings": "Gegevens",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Na de proefperiode zal het normale tarief in rekening worden gebracht voor het door jou gekozen abonnement.",
    "Already a member?": "Al lid?",
    "An error occurred": "Er is een fout opgetreden",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Er trad een onverwachte fout op. Probeer het opnieuw of <a>neem contact op met de support</a> als de fout aanhoudt.",
    "Back": "Terug",
    "Back to Log in": "Terug naar inloggen",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Altijd opzegbaar.",
    "Cancel subscription": "Abonnement opzeggen",
    "Canceled": "",
    "Cancellation reason": "Reden voor opzegging",
    "Change": "Wijzigen",
    "Change plan": "Wijzig abonnement",
    "Check spam & promotions folders": "Check je spam en promotie mappen",
    "Check with your mail provider": "Check bij je e-mailprovider",
    "Check your inbox to verify email update": "Check je inbox om de e-mailupdate te verifiëren",
    "Choose": "Kies",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Kies een ander abonnement",
    "Choose a plan": "Kies een abonnement",
    "Choose a tier": "",
    "Choose your newsletters": "Kies jouw nieuwsbrieven",
    "Click here to retry": "Klik hier om opnieuw te proberen",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Sluiten",
    "Code": "",
    "Comment preferences updated.": "Reactievoorkeuren bijgewerkt.",
    "Comments": "Reacties",
    "Complimentary": "Gratis",
    "Confirm": "Bevestigen",
    "Confirm cancellation": "Bevestig opzegging",
    "Confirm subscription": "Bevestig abonnement",
    "Contact support": "Contacteer support",
    "Continue": "Doorgaan",
    "Continue subscription": "Doorgaan met abonnement",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Kon geen Stripe-afrekensessie maken",
    "Could not sign in. Login link expired.": "Kon niet inloggen. Login-link is verlopen.",
    "Could not update email! Invalid link.": "Kon e-mail niet bijwerken! Ongeldige link.",
    "Create a new contact": "Maak een nieuw contact",
    "Current plan": "Huidig abonnement",
    "Delete account": "Account verwijderen",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Dit niet bedoeld? Beheer je voorkeuren <button>hier</button>.",
    "Don't have an account?": "Heb je nog geen account?",
    "Edit": "Bewerken",
    "Email": "E-mail",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Nieuwsbrief",
    "Email newsletter settings updated": "Instellingen voor nieuwsbrief bijgewerkt",
    "Email preferences": "E-mailinstellingen",
    "Email preferences updated.": "E-mailinstellingen bijgewerkt.",
    "Emails": "E-mails",
    "Emails disabled": "E-mails zijn uitgeschakeld",
    "Ends {offerEndDate}": "Eindigt op {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Vul je e-mailadres in",
    "Enter your name": "Vul je naam in",
    "Error": "Fout",
    "Expires {expiryDate}": "Verloopt op {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Annulering van abonnement mislukt, probeer het opnieuw",
    "Failed to log in, please try again": "Inloggen mislukt, probeer het opnieuw",
    "Failed to log out, please try again": "Uitloggen mislukt, probeer het opnieuw",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Afrekenen mislukt, probeer het opnieuw",
    "Failed to send magic link email": "Magische link-e-mail verzenden mislukt",
    "Failed to send verification email": "Verificatie-e-mail verzenden mislukt",
    "Failed to sign up, please try again": "Registratie mislukt, probeer het opnieuw",
    "Failed to update account data": "Bijwerken van accountgegevens mislukt",
    "Failed to update account details": "Bijwerken van accountdetails mislukt",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Bijwerken van nieuwsbriefinstellingen mislukt",
    "Failed to update subscription, please try again": "Bijwerken van abonnement mislukt, probeer het opnieuw",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Voor altijd",
    "Free Trial – Ends {trialEnd}": "Gratis proefperiode - Eindigt op {trialEnd}",
    "From": "",
    "Get help": "Krijg hulp",
    "Get in touch for help": "Neem contact op voor hulp",
    "Get notified when someone replies to your comment": "Blijf op de hoogte als iemand op jouw reactie reageert",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Deel je mening over dit artikel",
    "Help! I'm not receiving emails": "Help! Ik ontvang geen e-mails",
    "Here are a few other sites you may enjoy.": "Hier zijn enkele andere sites die je misschien leuk vindt.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Als een nieuwsbrief als spam wordt gemarkeerd, worden e-mails voor dat adres automatisch uitgeschakeld om te voorkomen dat je ongewenste berichten ontvangt.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Als de spamklacht per ongeluk was, of als je weer e-mails wilt ontvangen, kun je je opnieuw abonneren door op de knop op het vorige scherm te klikken.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Als je nu opzegt, behoud je toegang tot {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Als je een zakelijk of overheidsmailaccount hebt, vraag je IT-afdeling om e-mails van {senderEmail} toe te staan.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Je hebt een e-mail met een login link ontvangen. Controleer je spamfolder als hij niet binnen 3 minuten aankomt.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Als je weer e-mails wilt ontvangen, controleer dan je opgeslagen e-mailadres en klik op de vorige pagina op opnieuw abonneren.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Als je de nieuwsbrief die je hebt geabonneerd niet ontvangt, zijn hier enkele dingen om te controleren.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Als je alle stappen hebt doorlopen en nog steeds geen e-mails ontvangt, kun je contact opnemen met {supportAddress} voor hulp.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Als een permanente fout optreedt bij het verzenden van een nieuwsbrief, worden e-mails voor het account uitgeschakeld.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Voeg {senderEmail} toe aan je contactenlijst in je e-mailprogramma. Dit geeft aan dat e-mails van dit adres vertrouwd moeten worden.",
    "Invalid email address": "Ongeldig e-mailadres",
    "Invalid verification code": "",
    "Jamie Larson": "Jan Jansen",
    "jamie@example.com": "jan@voorbeeld.nl",
    "Less like this": "Minder hiervan",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Zorg ervoor dat e-mails niet per ongeluk in je spam- of promotie-mappen belanden. Klik op 'Markeer als geen spam' en/of 'Verplaatsen naar inbox' als dat wel het geval is.",
    "Manage": "Beheer",
    "Maybe later": "Misschien later",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Lidmaatschappen niet beschikbaar, neem contact op met de eigenaar.",
    "month": "maand",
    "Monthly": "Maandelijks",
    "More like this": "Meer hiervan",
    "More options": "",
    "Name": "Naam",
    "Need more help? Contact support": "Meer hulp nodig? Contacteer support",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Nieuwsbrieven kunnen om twee redenen zijn uitgeschakeld voor je account: een eerdere e-mail werd als spam gemarkeerd, of het verzenden van een e-mail resulteerde in een permanente fout (bounce).",
    "No member exists with this e-mail address.": "Er bestaat geen lid met dit e-mailadres.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ontvang je geen e-mails?",
    "Now": "",
    "Now check your email!": "Check nu je e-mail!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Als je opnieuw geabonneerd bent en je ziet nog steeds geen e-mails in je inbox, controleer dan je spammap. Sommige providers houden een register bij van eerdere spamklachten en blijven e-mails markeren. Markeer de nieuwste nieuwsbrief als 'Geen spam' om deze terug te plaatsen naar je hoofdmap.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Permanente fout (bounce)",
    "Phone number": "Telefoonnummer",
    "Plan": "Abonnement",
    "Plan checkout was cancelled.": "Afrekenen abonnement geannuleerd.",
    "Plan upgrade was cancelled.": "Upgrade abonnement geannuleerd.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Neem contact op met {supportAddress} om je gratis abonnement aan te passen.",
    "Please enter {fieldName}": "Voer {fieldName} in",
    "Please fill in required fields": "Vul de vereiste velden in",
    "Podcasts": "",
    "Re-enable emails": "E-mails weer inschakelen",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Aanbevelingen",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Verlengt met {price}.",
    "Resume subscription": "",
    "Retry": "Opnieuw proberen",
    "Save": "Opslaan",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Inloglink versturen...",
    "Sending...": "Versturen...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Toon alles",
    "Sign in": "Inloggen",
    "Sign out": "Uitloggen",
    "Sign up": "Registreren",
    "Signup error: Invalid link": "Registratiefout: Ongeldige link",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Er ging iets mis, probeer het later opnieuw.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Sorry, er zijn momenteel geen aanbevelingen beschikbaar.",
    "Sorry, that didn’t work.": "Sorry, dat werkte niet.",
    "Spam complaints": "Spamklachten",
    "Start {amount}-day free trial": "Start gratis je {amount}-daagse proefperiode",
    "Starting {startDate}": "Start op {startDate}",
    "Starting today": "Start vandaag",
    "Submit feedback": "Deel je feedback",
    "Subscribe": "Abonneren",
    "Subscribed": "Geabonneerd",
    "Subscription plan updated successfully": "Abonnement succesvol bijgewerkt",
    "Success": "Succes",
    "Success! Check your email for magic link to sign-in.": "Succes! Check je e-mail voor de magische inloglink.",
    "Success! Your account is fully activated, you now have access to all content.": "Succes! Je account is volledig geactiveerd, je hebt nu toegang tot alle inhoud.",
    "Success! Your email is updated.": "Succes! Je e-mail is bijgewerkt.",
    "Successfully unsubscribed": "Succesvol uitgeschreven",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Bedankt voor je abonnement. Voordat je begint met lezen, staan hieronder enkele andere sites die je misschien leuk vindt.",
    "Thank you for your support": "Dank je voor je steun",
    "Thank you for your support!": "Bedankt voor je steun!",
    "Thanks for the feedback!": "Bedankt voor je feedback!",
    "That didn't go to plan": "Er ging iets mis",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Het e-mailadres dat we voor je hebben is {memberEmail} — als dit niet klopt, kun je dit bijwerken in je <button>accountinstellingen</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Er was een probleem bij het verzenden van je feedback. Probeer het later opnieuw.",
    "There was an error cancelling your subscription, please try again.": "Er was een fout bij het opzeggen van je abonnement, probeer het opnieuw.",
    "There was an error continuing your subscription, please try again.": "Er was een fout bij het voortzetten van je abonnement, probeer het opnieuw.",
    "There was an error processing your payment. Please try again.": "Er was een fout bij het verwerken van je betaling, probeer het opnieuw.",
    "There was an error sending the email, please try again": "Er was een fout bij het verzenden van de e-mail, probeer het opnieuw",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Deze site is alleen toegankelijk op uitnodiging, neem contact op met de eigenaar.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Deze site accepteert momenteel geen betalingen.",
    "This site only accepts paid members.": "Deze site accepteert alleen betalende leden.",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Klik op de bevestigingslink in de e-mail om je registratie af te ronden. Check ook je spamfolder als hij niet binnen de 3 minuten aankomt.",
    "To continue to stay up to date, subscribe to {publication} below.": "Om op de hoogte te blijven, abonneer je op {publication} hieronder.",
    "Too many attempts try again in {number} days.": "Te veel pogingen, probeer het opnieuw over {number} dagen.",
    "Too many attempts try again in {number} hours.": "Te veel pogingen, probeer het opnieuw over {number} uur.",
    "Too many attempts try again in {number} minutes.": "Te veel pogingen, probeer het opnieuw over {number} minuten.",
    "Too many different sign-in attempts, try again in {number} days": "Te veel verschillende inlogpogingen, probeer het opnieuw over {number} dagen.",
    "Too many different sign-in attempts, try again in {number} hours": "Te veel verschillende inlogpogingen, probeer het opnieuw over {number} uur.",
    "Too many different sign-in attempts, try again in {number} minutes": "Te veel verschillende inlogpogingen, probeer het opnieuw over {number} minuten.",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Probeer gratis voor {amount} dagen, daarna {originalPrice}.",
    "Unable to initiate checkout session": "Kan afrekeningssessie niet starten",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Ontgrendel toegang tot alle nieuwsbrieven door een betalende abonnee te worden.",
    "Unsubscribe from all emails": "Uitschrijven voor alles",
    "Unsubscribed": "Uitgeschreven",
    "Unsubscribed from all emails.": "Uitgeschreven van alle e-mails.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Je betaalde abonnement voor {title} wordt niet geannuleerd als je je uitschrijft voor e-mails.",
    "Update": "Bijwerken",
    "Update your preferences": "Voorkeuren aanpassen",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Verificatielink verzonden, controleer je inbox",
    "Verify your email address is correct": "Controleer of je e-mailadres correct is",
    "Verifying...": "",
    "View plans": "Bekijk abonnementen",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Het is niet gelukt om je uit te schrijven, omdat je e-mailadres niet is gevonden. Neem contact op met de eigenaar.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Welkom terug, {name}!",
    "Welcome back!": "Welkom terug!",
    "Welcome to {siteTitle}": "Welkom bij {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Als een inbox een e-mail niet kan accepteren, wordt dit een bounce genoemd. In veel gevallen kan dit tijdelijk zijn. In sommige gevallen kan een bounced e-mail worden geretourneerd als een permanente fout wanneer een e-mailadres ongeldig of niet-bestaand is.",
    "Why has my email been disabled?": "Waarom is mijn e-mail uitgeschakeld?",
    "X (Twitter)": "",
    "year": "jaar",
    "Yearly": "Jaarlijks",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Je hebt momenteel een gratis lidmaatschap, upgrade naar een betaald abonnement voor volledige toegang.",
    "You have been successfully resubscribed": "Je bent weer succesvol geabonneerd",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Je ontvangt momenteel geen e-mails",
    "You're not receiving emails": "Je ontvangt geen e-mails",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Je ontvangt geen e-mails omdat je ofwel een recent bericht als spam had gemarkeerd, of omdat de berichten niet verzonden konden worden naar jouw e-mailadres.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Je bent succesvol ingelogd.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Je bent succesvol geabonneerd op <strong>{siteTitle}</strong>",
    "Your account": "Jouw account",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Je e-mail is niet opnieuw geabonneerd, probeer het opnieuw",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Jouw mening helpt bepalen wat er gepubliceerd wordt.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Je abonnement verloopt op {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Je abonnement wordt verlengd op {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Je abonnement begint op {subscriptionStart}"
}
